define('Store.Selector.Collection', [
    'Store.Collection',
    'Backbone.CachedCollection',
    'Utils'
], function StoreSelectorCollection(
    StoreCollection,
    CachedModel,
    Utils
) {
    'use strict';

    return StoreCollection.extend({
        url: Utils.getAbsoluteUrl(getExtensionAssetsPath('services/Store.Selector.Service.ss'))
    });
});
